import { render, staticRenderFns } from "./orderSeting.vue?vue&type=template&id=72b96f52&scoped=true&"
import script from "./orderSeting.vue?vue&type=script&lang=js&"
export * from "./orderSeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b96f52",
  null
  
)

export default component.exports